import { WiredServiceRecordEventList } from '@euler/app/flows/record/components/ServiceRecordEventList';
import { Aside } from '@euler/components/Aside';
import { LayoutProviderView } from '@euler/components/layout/LayoutProvider';
import { adaptiveWrapperOptions } from '@euler/functions/navigationOptionsBuilder';
import {
  isMobileLayout,
  useIsMobileLayout,
} from '@euler/functions/responsiveness';
import { useSystemMetrics } from '@euler/functions/useSystemMetrics';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import React from 'react';

export const ServiceRecordTimelinePage = wrapNavigatorScreen(
  () => {
    const isMobile = useIsMobileLayout();
    const { statusBarHeight } = useSystemMetrics();
    if (isMobile) {
      return <WiredServiceRecordEventList />;
    }
    return (
      <Aside dismissible>
        <LayoutProviderView
          css={`
            flex: 1;
          `}
        >
          <WiredServiceRecordEventList
            style={{
              paddingTop: statusBarHeight,
            }}
          />
        </LayoutProviderView>
      </Aside>
    );
  },
  adaptiveWrapperOptions<any>(() => ({
    title: '工作记录',
    headerStatusBarHeight: undefined,
    headerShown: isMobileLayout(),
  })),
);
